/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeManifest } from '@/styles/manifest';

export const themeManifestCustom: ThemeManifest = {
	defaultTheme: undefined,
	themes: {},
};
